import debug from "debug";
import getCookie from "./get-cookie";
import injectScript from "./inject-script";

const log = debug("sales-force-push");

class SalesForcePush {
    constructor(element, options) {
        this.element = element;
        this.options = options;

        log("SalesForcePush", element, options);

        if (!this.options.orgId) {
            log(
                `org id is required. e.g. data-sales-force-push-org-id="ORG_ID_HERE" Aborting.`
            );
            return false;
        }
        if (!this.options.scriptUrl) {
            log(
                `Link to the collect.js script is required. e.g. data-sales-force-push-script-url="https://[ORG_ID].collect.igodigital.com/collect.js" Aborting.`
            );
            return false;
        }
        if (!this.options.emailCookieName) {
            log(
                `user cookie name is required. e.g. data-sales-force-push-email-cookie-name="EmailAddr_" Aborting`
            );
            return false;
        }

        if (this.options.cartItemSelector) {
            this.cartItems = Array.from(
                document.querySelectorAll(this.options.cartItemSelector)
            );
        }

        this.getValueMethod =
            this.cartItems && this.cartItems.length
                ? this.getCartPushValue
                : this.getPushValue;

        this.init();
    }

    init() {
        this.inject().then(()=> {
            this.watch();
            if (this.options.key) {
                this.push(this.options.key, this.getValueMethod());
            }
        }).catch((error) => {
            log(`Error injecting script: ${error}`);
        });
    }

    watch() {
        document.addEventListener(
            this.options.cartUpdatedEvent,
            this.pushCartUpdate.bind(this)
        );
    }

    inject() {
        const src = this.options.scriptUrl.replace(
            this.options.scriptUrlIdToken,
            this.options.orgId
        );
        return injectScript(src);
    }

    pushCartUpdate(event) {
        const newCart = event.detail;
        if (newCart && newCart.length) {
            // setOrgId and setUserInfo set with trackPageView already
            _etmc.push(["trackCart", { cart: newCart }]);
        }
    }

    push(key, value) {
        const userEmailValue = getCookie(this.options.emailCookieName);
        if (!userEmailValue) {
            log(
                `No cookie value found for ${this.options.emailCookieName} Aborting`
            );
            return false;
        }
        window._etmc = window._etmc || [];
        _etmc.push(["setOrgId", this.options.orgId]);
        _etmc.push(["setUserInfo", { email: userEmailValue }]);
        _etmc.push([key, value]);
    }

    getPushValue() {
        return this.options.value;
    }

    getCartPushValue() {
        return Object.assign(
            { cart: this.getCartData() },
            this.options.value || {}
        );
    }

    getCartData() {
        return this.cartItems.map((item) => {
            return this.getCartItemData(item);
        });
    }

    getCartItemData(element) {
        return this.options.cartItemKeys.reduce((data, key) => {
            return Object.assign({}, data, { [key]: element.dataset[key] });
        }, {});
    }
}

SalesForcePush.DEFAULTS = {
    cartItemKeys: ["item", "quantity", "price", "unique_id"],
    cartUpdatedEvent: "cart-updated",
    scriptUrlIdToken: "[ORG_ID]",
};

export default SalesForcePush;

/*
data-sales-force-push
data-sales-force-push-org-id=""
data-sales-force-push-email-cookie-name="EmailAddr_"
data-sales-force-push-key="trackPageView"
data-sales-force-push-value='{ "category" : "Fencing" }'

data-sales-force-push-value=`{
    "order_number" : "TESTONLY",
    "discount" : "0.00",
    "shipping" : "10.00"
}`
data-sales-force-push-cart-item-selector="[data-sales-force-push--item]"
...
data-sales-force-push--item='{"item" : "TEST1234SKU2", "quantity":  "2" , "price" : "10.00" ,"unique_id" : "TEST1234SKU2" }'



// Every push - bake into js

["setOrgId", "7229597"]

["setUserInfo",
    {"email": getCookie("EmailAddr_")}
]


// Instance specific:

["trackPageView",
    { "category" : "Fencing" }
]

["trackCart",
    { "clear_cart": true }
]

["trackPageView",
    { "search" : "Fencing" }
]

["trackCart",
    { "cart": [
        {"item" : "TEST1234SKU2", "quantity":  "2" , "price" : "10.00" , "unique_id" : "TEST1234SKU2" }
    ]}
]

["trackConversion",
    {
        "cart": [
            {"item" : "TEST1234SKU2", "quantity":  "2" , "price" : "10.00" ,"unique_id" : "TEST1234SKU2" }
        ],

        // OPTIONAL PARAMETERS
        "order_number" : "TESTONLY",
        "discount" : "0.00",
        "shipping" : "10.00"
    }
]

*/



// WEBPACK FOOTER //
// ./project/client/src/core/modules/sales-force-push/sales-force-push.js